import { Component, OnDestroy, inject } from "@angular/core";
import {
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";
import { DialogHeaderComponent } from "@app/view/shared/dialog-header/dialog-header.component";
import { Store, select } from "@ngrx/store";
import { selectorAuth } from "@app/core";
import { Subscription } from "rxjs";

@Component({
  selector: "app-confirm-skill-changes-dialog",
  templateUrl: "./confirm-skill-changes-dialog.component.html",
  styleUrls: ["./confirm-skill-changes-dialog.component.scss"],
  imports: [
    DialogHeaderComponent,
    CdkScrollable,
    MatDialogContent,
    MatIcon,
    MatDialogActions,
    MatButton
  ]
})
export class ConfirmSkillChangesDialogComponent implements OnDestroy {
  private dialogRef =
    inject<MatDialogRef<ConfirmSkillChangesDialogComponent>>(MatDialogRef);
  private store = inject<Store<any>>(Store);

  isAdmin = false;
  private authSubscription: Subscription;

  constructor() {
    this.authSubscription = this.store
      .pipe(select(selectorAuth))
      .subscribe((auth) => {
        this.isAdmin = !!auth && auth.isAdmin;
      });
  }

  ngOnDestroy(): void {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
